import http from "../../util/axios";

export default {
  //获取学生端导航栏图片
  getUserNavBarImg() {
    return http.get("/commonSetting/getUserNavBarImg");
  },
};



// WEBPACK FOOTER //
// ./src/api/confirmIdentity/index.js